module.exports = function() {
  return new Worker(__webpack_public_path__ + "32e1de5e428db1793273.worker.js");
};